import { styled } from '@/stitches.config';
import { keyframes } from '@stitches/react';

export function LoadingIcon() {
  return (
    <Container>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 64 64"
      >
        <path
          d="M63.8,38.5l-9.4-9.1l-9.1,9.4l1.6,1.5l6.5-6.7c-0.1,2-0.6,4-1.3,6c-4.2,11-16.5,16.6-27.5,12.4c-5.3-2-9.6-6-11.9-11.2
		c-2.3-5.2-2.5-11-0.5-16.3c2-5.3,6-9.6,11.2-11.9c2.8-1.3,5.8-1.9,8.8-1.9c0.1,0,0.2,0,0.3,0l0.1-2.2c-3.4-0.1-6.8,0.6-10,2.1
		c-5.7,2.6-10.1,7.2-12.3,13.1s-2,12.3,0.6,18c2.6,5.7,7.2,10.1,13.1,12.3c2.7,1,5.5,1.5,8.3,1.5c9.5,0,18.5-5.8,22-15.2
		c0.9-2.3,1.3-4.6,1.5-6.9l6.8,6.6L63.8,38.5z"
        />
      </svg>
    </Container>
  );
}

const rotateAnimation = keyframes({
  '0%': { transform: 'rotate(360deg)' },
  '100%': { transform: 'rotate(0deg)' },
});

const Container = styled('div', {
  width: 20,
  height: 20,
  marginRight: '$3',

  svg: {
    fill: '$foreground',
    animation: `${rotateAnimation} 2.5s linear infinite`,
  },
});
